import { Project } from 'lib/project/types.d'
import { RootState } from 'store/root-reducer'

// eslint-disable-next-line import/prefer-default-export
export const selectCurrentTreeItemRef = (
  state: RootState,
): Project.GenericRef<Project.AnyRequestTreeItem> | null =>
  state.uiState.currentItemState.currentTreeItemRef
